<template>
  <v-dialog
    v-model="dialog"
    @keydown.esc="onDialogClose"
    persistent
    scrollable
    width="850px"
  >
    <v-card color="white" flat tile v-if="quotation != null">
      <v-card-title class="dialog-header-title"> Upload quotation files </v-card-title>
      <v-card-text class="py-0" style="height: 450px">
        <v-row no-gutters>
          <v-col>
            <quotation-file-upload v-model="quotation"></quotation-file-upload>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-5">
        <v-row justify="end">
          <v-btn
            tile
            depressed
            class="font-weight-bold mr-2"
            color="primary"
            @click="onSave"
            >SAVE</v-btn
          >
          <v-btn
            tile
            depressed
            class="font-weight-bold ml-2"
            color="error"
            @click="onDialogClose"
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "../../const";
import QuotationFileUpload from "@/components/shared/QuotationFileUpload.vue";

export default {
  props: ["quotation", "dialog"],

  components: {
    QuotationFileUpload,
  },
  data() {
    return {};
  },
  watch: {
    // dialog: function () {
    //   if (this.dialog) {
    //   }
    // },
  },

  methods: {
    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_QUOTATION_FILES, null, false);
    },

    onSave() {
      var response = null;

      this.$root.blockUImsg = "Saving quotation...";
      this.$root.blockUIshow = true;

      this.$https
        .put("/api/quotations/" + this.quotation.quotation_id, this.quotation)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
            this.quotation = response.data;
            this.quotationUpdated = true;
          } else {
            console.log("Error saving quotation", response);
          }
          this.$root.blockUIshow = false;
        });
    },
  },

  computed: {
    isAdmin() {
      return this.$store.state.user.role == constant.ACCOUNT_ADMIN;
    },
  },
};
</script>

<style></style>
